import { ComponentSettings, FieldTypes } from "../settings/settings";

const field = {
  manufacturerName: {
    type: FieldTypes.value,
    text: {
      de: "Herstellername",
      en: "Manufacturer Name",
      nl: "Manufacturer Name"
    }
  },
  responsible: {
    type: FieldTypes.value,
    text: {
      de: "Verantwortlicher",
      en: "Responsible",
      nl: "Verantwoordelijke"
    }
  }
};

const settings = {
  permission: {},
  text: {
    manufacturerResponsibles: {
      de: "Hersteller Verantwortliche",
      en: "Manufacturer Responsibles",
      nl: "Manufacturer Responsibles"
    }
  },
  url: {},
  field,
  list: {},
  additionalInfo: {}
};

export const manufacturerResponsibles: ComponentSettings<typeof settings> =
  settings;
